import { Flex } from "Element/Flex";
import styled from "styled-components";

export const BoxContainer = styled.div`
  padding: 40px 72px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 24px;
  `}
`;

export const Box = styled(Flex)`
  padding: 40px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 16px;
  `}
  background-color: ${({ theme }) => theme.colors.neutral20};
  border-radius: 12px;
`;

export const StyledDesc = styled.p`
  width: 550px;
  margin: 0;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: auto;
    text-align: center;
  `}
`;
export const StyledTitle = styled.h1`
  margin-bottom: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    text-align: center;
  `}
`;

export const ButtonWrapper = styled(Flex)`
  button {
    :first-child {
      margin-bottom: 16px;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `}
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    margin-top: 64px;
  `}
`;
